try {
    require('bootstrap');
} catch (e) {}